import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getEnrollmentsPickupListCount(centerId: number) {
  return restApiClient
    .url(constructApiUrl(API.centers.getEnrollmentsPickupListCount.url, { id: centerId }))
    .get<{ count: number }>()
}
